import React from "react";
import { AlertTriangle, Check, Loader2 } from "lucide-react";
import { AppProvider, useApp } from "./context/AppContext";
import CompaniesPage from "./pages/CompaniesPage";
import LeadsPage     from "./pages/LeadsPage";
import PipelinePage  from "./pages/PipelinePage";
import InsightsPage  from "./pages/InsightsPage";
import GrowthPage    from "./pages/GrowthPage";
import QualityPage   from "./pages/QualityPage";
import SendPage      from "./pages/SendPage";
import AdminPage          from "./pages/AdminPage";
import CompanyDetailPage  from "./pages/CompanyDetailPage";
import LandingPage        from "./pages/LandingPage";
import PortfolioPage       from "./pages/PortfolioPage";
import DashboardPage       from "./pages/DashboardPage";
import CampaignModal from "./components/CampaignModal";
import DecisionModal from "./components/DecisionModal";
import HelpButton from "./components/HelpButton";
import { colors } from "./theme";

const PAGE_MAP = {
  landing:   LandingPage,
  dashboard: DashboardPage,
  portfolio: PortfolioPage,

  companies: CompaniesPage,
  leads:     LeadsPage,
  pipeline:  PipelinePage,
  insights:  InsightsPage,
  growth:    GrowthPage,
  quality:   QualityPage,
  send:          SendPage,
  admin:         AdminPage,
  companyDetail: CompanyDetailPage,
};

const toastBase = {
  position:"fixed", bottom:24, left:"50%", transform:"translateX(-50%)",
  color:"#fff", padding:"10px 20px", borderRadius:8,
  fontSize:12, fontWeight:600, zIndex:9999,
  boxShadow:"0 4px 16px rgba(0,0,0,0.3)", pointerEvents:"none",
  display:"flex", alignItems:"center", gap:8, whiteSpace:"nowrap",
};

function AccessDenied() {
  return (
    <div style={{ display:"flex", height:"100vh", alignItems:"center", justifyContent:"center",
      flexDirection:"column", gap:10, fontFamily:"'Montserrat',sans-serif",
      background:colors.surface?.subtle || "#f4f5f7", color:colors.text?.body || "#374151", textAlign:"center", padding:24 }}>
      <div style={{ fontSize:34, fontWeight:900, color:colors.brand?.primary || "#E8431A" }}>Compass</div>
      <div style={{ fontSize:18, fontWeight:800, color:colors.text?.heading || "#111827" }}>No access</div>
      <div style={{ fontSize:13, maxWidth:420, lineHeight:1.6 }}>
        Your account isn't set up in Compass. Ask a Data Admin to add you to the users list,
        then sign in again.
      </div>
    </div>
  );
}

function AppInner() {
  const { view, toast, savingCount, accessDenied } = useApp();
  if (accessDenied) return <AccessDenied />;
  const Page = PAGE_MAP[view] || PortfolioPage;
  return (
    <>
      <Page />
      <CampaignModal />
      <DecisionModal />
      <HelpButton />
      {toast ? (
        <div style={{ ...toastBase, background: toast.type === "error" ? colors.status.bad : colors.text.heading }}>
          {toast.type === "error" ? <AlertTriangle size={14} /> : <Check size={14} />}
          {toast.msg}
        </div>
      ) : savingCount > 0 ? (
        <div style={{ ...toastBase, background:colors.text.body }}>
          <Loader2 size={14} style={{ animation:"spin 1s linear infinite" }} />
          Saving…
        </div>
      ) : null}
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      <AppInner />
    </AppProvider>
  );
}
